import { Controller } from "stimulus";
import Cookies from "js-cookie";

export default class extends Controller {
  static targets = ["products"]

  connect() {
    if(!Cookies.get("hoveredProductsNav")){
      this.productsTarget.classList.remove("tw-hidden")
    }
  }

  hoverProductsNav(event) {
    Cookies.set("hoveredProductsNav", true, { expires: 365, path: ""});
    this.productsTarget.classList.add("tw-hidden")
  }
}
